<!-- Subscription Details Component -->
<div class="flex flex-column gap-1" data-testid="subscription-details">
  <!-- Row 1: Name + category (desktop) -->
  <div class="flex align-items-center gap-2">
    <div
      class="text-sm font-medium text-900 line-height-2 min-w-0"
      [attr.data-testid]="'subscription-name'"
      [title]="subscriptionDisplayTitle"
    >
      {{ subscriptionName }}
    </div>

    @if (showCategory) {
      <span
        class="hidden md:inline-flex align-items-center white-space-nowrap text-xs px-2 py-1 border-round font-medium flex-shrink-0"
        [ngClass]="categoryClass"
        data-testid="subscription-category"
        [attr.aria-label]="'subscription-category-' + subscriptionCategory"
      >
        {{ subscriptionCategory }}
      </span>
    }
  </div>

  <!-- Row 2: category (mobile) + status badges -->
  <div class="flex align-items-center gap-2 flex-wrap">
    @if (showCategory) {
      <span
        class="inline-flex md:hidden align-items-center white-space-nowrap text-xs px-2 py-1 border-round font-medium flex-shrink-0"
        [ngClass]="categoryClass"
        [attr.aria-label]="'subscription-category-' + subscriptionCategory"
      >
        {{ subscriptionCategory }}
      </span>
    }

    <span
      class="text-xs px-2 py-1 border-round font-medium uppercase flex-shrink-0"
      [ngClass]="statusClass"
      [attr.data-testid]="'subscription-status'"
      [attr.aria-label]="'subscription-status-' + subscriptionStatus"
    >
      {{ subscriptionStatus }}
    </span>

    @if (showManualOverrideBadge) {
      <span
        class="inline-flex align-items-center text-xs px-2 py-1 border-round font-bold uppercase flex-shrink-0 bg-orange-100 text-orange-600 border-1 border-orange-200 white-space-nowrap"
        [pTooltip]="'SUBSCRIPTIONS.MANUAL_OVERRIDE_TOOLTIP' | translate"
        tooltipPosition="top"
        aria-label="manual-override-badge"
      >
        {{ 'SUBSCRIPTIONS.MANUAL_OVERRIDE_BADGE' | translate }}
      </span>
    }

    @if (
      showSubscriptionDates &&
      !showManualOverrideBadge &&
      (subscriptionStartDate || subscriptionEndDate || showInfiniteEndDate)
    ) {
      <span
        class="hidden md:inline text-xs text-600 line-height-2 white-space-nowrap"
        data-testid="subscription-dates"
        aria-label="subscription-dates"
      >
        @if (subscriptionStartDate) {
          <span data-testid="subscription-start-date" aria-label="subscription-start-date">
            {{ subscriptionStartDate | datetimeformat: 'dateOnly' }}
          </span>
        }
        @if (subscriptionStartDate && (subscriptionEndDate || showInfiniteEndDate)) {
          <span aria-hidden="true"> - </span>
        }
        @if (showInfiniteEndDate) {
          <i
            class="fa-solid fa-infinity text-600"
            data-testid="subscription-end-date-infinite"
            aria-label="subscription-end-date-infinite"
          ></i>
        } @else if (subscriptionEndDate) {
          <span data-testid="subscription-end-date" aria-label="subscription-end-date">
            {{ subscriptionEndDate | datetimeformat: 'dateOnly' }}
          </span>
        }
      </span>
    }
  </div>

  @if (showSubscriptionDates && (subscriptionStartDate || subscriptionEndDate || showInfiniteEndDate)) {
    <div
      class="text-xs text-600 line-height-2 white-space-nowrap"
      [class.md:hidden]="!showManualOverrideBadge"
      data-testid="subscription-dates-row"
      aria-label="subscription-dates-row"
    >
      @if (subscriptionStartDate) {
        <span data-testid="subscription-start-date-mobile" aria-label="subscription-start-date">
          {{ subscriptionStartDate | datetimeformat: 'dateOnly' }}
        </span>
      }
      @if (subscriptionStartDate && (subscriptionEndDate || showInfiniteEndDate)) {
        <span aria-hidden="true"> - </span>
      }
      @if (showInfiniteEndDate) {
        <i
          class="fa-solid fa-infinity text-600"
          data-testid="subscription-end-date-infinite"
          aria-label="subscription-end-date-infinite"
        ></i>
      } @else if (subscriptionEndDate) {
        <span data-testid="subscription-end-date-mobile" aria-label="subscription-end-date">
          {{ subscriptionEndDate | datetimeformat: 'dateOnly' }}
        </span>
      }
    </div>
  }
</div>
